module.exports = __webpack_public_path__ + "img/kuaishou-coupon-vertify-icon.1a46db84.png";